import service from './index'

/**
 * 不需登录的接口请求
 * @param {Object} config 
 * @returns 
 */
const PublicService = config => service({
  ...config,
  public: true,
})

export default PublicService